import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './AiMark.module.scss';

type Props = {
  className?: string;
};

export const AiMark: FC<Props> = ({ className }) => (
  <span className={cn('p5', styles.mark, className)}>
    <FormattedMessage id="workspace.template.aiMark" defaultMessage="AI" />
  </span>
);
